import { bindActionCreators, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';

import AsyncTasksPage from './AsyncTasksPage';
import State from '../../app/store/state';
import { ActionCreators as AsyncActionCreators, AsyncTasksTypes } from '../../utils/asyncTasks';
import { ActionCreators as BeneficiaryActionCreators } from '../beneficiaries';
import { hasFeatureAccess } from '../../login/auth';
import { ManagerPermission } from '../../permission-profiles/permission';

const blockWithoutZeroingMapping = {
    beneficiaryId: 1,
    reason: 2,
    source: 3,
};

function mapDispatchToProps(dispatch: ThunkDispatch<unknown, void, AnyAction>) {
    return {
        authorizeTask: bindActionCreators(AsyncActionCreators.authorizeAsyncTask, dispatch),
        downloadFile: bindActionCreators(AsyncActionCreators.downloadFile, dispatch),
        loadAsyncTasksList: (page, limit) =>
            dispatch(AsyncActionCreators.loadAsyncTasksList(page, limit, AsyncTasksTypes.BLOCK_BENEFICIARIES)),
        uploadFile: (data: File, dryRun?: boolean, dryRunAsyncTaskId?: string) => {
            const params: Record<string, unknown> = {
                data,
                mapping: blockWithoutZeroingMapping,
                startIndex: 2,
            };

            if (dryRun) {
                params.dryRun = true;
            }
            if (dryRunAsyncTaskId) {
                params.dryRunAsyncTaskId = dryRunAsyncTaskId;
            }

            return dispatch(BeneficiaryActionCreators.blockBeneficiaries(params));
        },
        clearUploadTask: bindActionCreators(BeneficiaryActionCreators.clearUploadTask, dispatch),
    };
}

function mapStateToProps(state: State) {
    const hasBeneficiariesMassBlockPost = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesMassBlockPost);
    const hasBeneficiariesMassBlockPark = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesMassBlockPark);
    const canDownload = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesDownload);

    return {
        canPark: hasBeneficiariesMassBlockPark,
        canPost: hasBeneficiariesMassBlockPost,
        canDownload: canDownload,
        tasks: state.asyncTasks.asyncTasks[AsyncTasksTypes.BLOCK_BENEFICIARIES],
        authorizedManagerId: state.auth.manager ? state.auth.manager.id : null,
        exampleUploadFile: 'BeneficiaryMassBlockTest.xlsx',
        name: 'Block Beneficiaries',
        uploadDescription: 'Upload XLSX file with blocked beneficiaries with proper structure.',
        exampleLinkTitle: 'See example mass block file',
        uploadTaskState: state.uploadTaskState,
        shouldRunDryRun: true,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect(mapStateToProps, mapDispatchToProps)(AsyncTasksPage as any);
